import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import TodayIcon from '@mui/icons-material/Today';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type ScheduleHeaderProps = {
  selectedDate: string;
  onTodayClick: () => void;
};

export const ScheduleHeader = ({ selectedDate, onTodayClick }: ScheduleHeaderProps) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const BackArrow = i18n.dir() === 'rtl' ? ArrowForwardIcon : ArrowBackIcon;
  const isToday = moment(selectedDate).isSame(moment(), 'day');

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <IconButton onClick={() => navigate('/passes/dashboard')}>
        <BackArrow />
      </IconButton>
      <Typography variant="h6" fontWeight={600}>
        {moment(selectedDate).format('MMMM YYYY')}
      </Typography>
      <IconButton onClick={onTodayClick} disabled={isToday} sx={{ opacity: isToday ? 0.3 : 1 }}>
        <TodayIcon />
      </IconButton>
    </Grid>
  );
};
